module.exports = __webpack_public_path__ + "img/02_sub_no.bb78b38f.svg";